import globalStore from "../store/globalStore";
import router from '@/router';

/**
 * API error: wrong credentials: login/password or cookie
 */
export class CredentialsError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "CredentialsError";
        router.push({ name: 'Login'})
        globalStore.dispatch("logout");
    }
}

/**
 * Any inner backend error that frontend can't handle 
 */
export class BackendError extends Error {
    constructor(message: { [key: string]: string; }) {
        super(message.message);
        this.name = "BackendError";
    }
}

/**
 * API error: too many requests (HTTP 429)
 */
export class TooManyRequestsError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "TooManyRequestsError";
    }
}

export class InvalidInputError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "InvalidInputError";
    }
}

export class InvalidDataError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "InvalidDataError";
    }
}

interface BackendErrorData {
  status: string;
  code: number;
}

export class BackendStatusError extends Error {
    status: string
    code: number

    constructor(data: BackendErrorData) {
        super(data.status);
        this.name = "BackendStatusError";
        this.status = data.status;
        this.code = data.code
    }
}